@for (row of rows().controls; track $index) {
    <app-fuel-row [group]="row" [fields]="fields" [units]="units()" [maxTank]="maxTank()"></app-fuel-row>
}
